<template>
  <div>
    <div class="text-center bg-FF h-vh-100 p-20">
      <img class="w-360 h-360 p-t-200" :src="`${image_base_url}/404.png`"></img>
      <div class="font-30 cor-8B m-t-30">系统跳转发生错误，请联系开发人员，谢谢~</div>
      <van-button>返回上一页</van-button>
    </div>
    <!--    <van-button type="primary" @click="getUserInfo">主要按钮</van-button>-->

  </div>
</template>

<script>
import {getInfo} from "@/api/login";
import {mapState} from "vuex";

export default {
  computed: {
    ...mapState({
      image_base_url: state => state.settings.image_base_url,
    })
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {
    getUserInfo() {
      this.$router.push('/flowRedirect')

    }
  }
}
</script>

<style scoped lang="less">

</style>